/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useProjectSharesCacheInvalidator } from './use-project-shares';

/**
 * Delete project share.
 */

function deleteProjectShare(client: AxiosInstance, projectId: string, shareId: number): Promise<any> {
  return client
    .delete(resolveAppUrl('projectShareById', { interpolations: { projectId, id: shareId } }))
    .then(({ data }) => data);
}

/**
 * Export `useDeleteProjectShare`.
 */

export function useDeleteProjectShare(projectId: string) {
  const client = useRequestProvider();
  const invalidator = useProjectSharesCacheInvalidator(projectId);

  return useMutation({
    mutationFn: async (shareId: number) => {
      const result = await deleteProjectShare(client, projectId, shareId);

      await invalidator();

      return result;
    }
  });
}
